import * as React from "react";
import { useSelector } from "react-redux";
import { Container, Loader } from "semantic-ui-react";

import { selectors as customerSelectors } from "../../crud/customer";
import { selectors as employeeRecordSelectors } from "../../crud/employeeRecord";
import { selectors as ohCaseSelectors } from "../../crud/ohCase";
import { selectors as taskSelectors } from "../../task";

import { CompleteConsultationButtons } from "./CompleteConsultationButtons";
import { MHPTreatmentConsultationSections } from "./MHPTreatmentConsultationSections";

export const MHPTreatmentConsultation: React.FunctionComponent = () => {
    const [showConsultationSections, setShowConsultationSections] = React.useState<boolean>(true);

    const customerId = useSelector(customerSelectors.routeIdSelector);
    const employeeRecordId = useSelector(employeeRecordSelectors.routeIdSelector);
    const taskId = useSelector(taskSelectors.taskIdSelector);

    const employeeRecord = useSelector(employeeRecordSelectors.employeeRecord);
    const ohCase = useSelector(ohCaseSelectors.ohCase);

    const task = ohCase && "tasks" in ohCase && ohCase.tasks.find(t => t.id === taskId);

    if (!task || !employeeRecord || !("detailUpdated" in employeeRecord)) {
        return (
            <Container className="clinical-notes">
                <Loader active />
            </Container>
        );
    }

    const readonly = task.completed;
    return (
        <Container className="clinical-notes">
            <h2 className={readonly ? "" : "sticky-header"}>
                Clinical Notes for {ohCase && `${ohCase.employeeFirstName} ${ohCase.employeeLastName}`}
            </h2>
            {!readonly &&
                <CompleteConsultationButtons
                    customerId={customerId}
                    employeeRecordId={employeeRecordId}
                    ohCaseId={ohCase.id}
                    task={task}
                    onDNAAction={setShowConsultationSections}
                />
            }
            {showConsultationSections &&
                <MHPTreatmentConsultationSections
                    customerId={customerId}
                    employeeRecord={employeeRecord}
                    ohCase={ohCase}
                    task={task}
                    readonly={readonly}
                />
            }
        </Container>
    );
};
